import React from "react";
import { Col, Container, Image, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

import AppNavbar from "../../components/common/AppNavbar";

const ThailandVisaGuide = () => {
  const categories = [
    {
      name: "Apply E-Visa",
      link: "https://thaievisa.go.th/",
    },
    {
      name: "Tourist Visa (TR)",
      link: "https://www.thaievisa.go.th/tourist-visa",
    },
    {
      name: "Visa on Arrival (VOA)",
      link: "https://www.thaievisa.go.th/visa-on-arrival",
    },
    {
      name: "Transit Visa",
      link: "https://www.thaievisa.go.th/transit-visa",
    },
    {
      name: "Business Visa (Non-B)",
      link: "https://www.thaievisa.go.th/business-visa",
    },
    {
      name: "Education Visa (ED)",
      link: "https://www.thaievisa.go.th/education-visa",
    },
    {
      name: "Retirement Visa (O-A / O-X)",
      link: "https://www.thaievisa.go.th/retirement-visa",
    },
    {
      name: "Marriage Visa (O)",
      link: "https://www.thaievisa.go.th/marriage-visa",
    },
    {
      name: "Permanent Residency",
      link: "https://www.immigration.go.th/",
    },
  ];

  return (
    <>
      <AppNavbar />
      <Container fluid className="my-4">
        <Row>
          <Col lg={9}>
            <h4 className="my-4 fw-bold">
              General Guidance on Thailand Immigration and Visas
            </h4>
            <ul>
              <li>
                <b>Visa Types:</b>
                <ul>
                  <li>
                    <b>Short-Stay Visas (up to 60–90 days):</b> Tourist Visa
                    (TR), Visa on Arrival (VOA), Transit Visa, Visa Exemption.
                  </li>
                  <li>
                    <b>Long-Stay Visas:</b> Non-Immigrant B (Business/Work),
                    Non-Immigrant ED (Education), Non-Immigrant O
                    (Family/Retirement), Retirement Visa (O-A, O-X), Marriage
                    Visa.
                  </li>
                  <li>
                    <b>Special Long-Term:</b> Thailand Elite Visa, Long-Term
                    Resident (LTR) Visa.
                  </li>
                </ul>
              </li>
              <li>
                <b>Requirements:</b> Valid passport (6+ months), visa form,
                photos, return ticket, proof of funds, hotel booking or Thai
                address, and purpose-specific docs (job contract, admission
                letter, marriage certificate, pension proof).
              </li>
              <li>
                <b>Application Process:</b>
                <ul>
                  <li>Choose visa type based on purpose.</li>
                  <li>Apply via Thai Embassy/Consulate or online (E-Visa).</li>
                  <li>Provide biometrics if required.</li>
                  <li>
                    Processing: Short-term 5–15 days; long-term several weeks.
                  </li>
                  <li>Collect visa and complete TM.6 arrival card at entry.</li>
                </ul>
              </li>
              <li>
                <b>Tips for Success:</b> Apply early (4–8 weeks), keep document
                copies, avoid overstaying (fine: 500 THB/day), and get a
                Re-Entry Permit for long stays if traveling abroad.
              </li>
              <li>
                <b>Helpful Resources:</b>{" "}
                <a
                  href="https://www.thaievisa.go.th"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Thailand E-Visa
                </a>
                ,{" "}
                <a
                  href="https://www.immigration.go.th/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Thailand Immigration Bureau
                </a>
                .
              </li>
            </ul>

            <Row className="g-0">
              {categories.map((category, index) => (
                <Col
                  lg={4}
                  key={index}
                  className="d-flex align-items-center p-2 border rounded shadow-sm bg-light hover-effect"
                >
                  <a
                    href={category.link}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {category.name}
                  </a>
                </Col>
              ))}
            </Row>

            <div className="text-center py-4">
              <h6 style={{ fontSize: "11px" }}>ADVERTISEMENT</h6>
              <div className="text-center">
                {/* Mobile: Display Image 1 */}
                <Row className="d-md-none">
                  <Col>
                    <img
                      src="https://ayg.s3.us-east-2.amazonaws.com/bharat/Beige+and+Maroon+traditional+Minimal+Guru+Purnima+Greeting+Instagram+Post.gif"
                      alt="Mobile"
                      className="img-fluid"
                    />
                  </Col>
                </Row>

                {/* Tablet: Display Image 2 */}
                <Row className="d-none d-md-flex d-lg-none">
                  <Col>
                    <img
                      src="https://ayg.s3.us-east-2.amazonaws.com/bharat/IMG-20240821-WA0057.jpg"
                      alt="Tablet"
                      className="img-fluid"
                    />
                  </Col>
                </Row>

                {/* Desktop: Display Image 3 */}
                <Row className="d-none d-lg-flex">
                  <Col>
                    <img
                      src="https://ayg.s3.us-east-2.amazonaws.com/bharat/IMG-20240821-WA0057.jpg"
                      alt="Desktop"
                      className="img-fluid"
                    />
                  </Col>
                </Row>
              </div>
            </div>
          </Col>

          <Col lg={3} md={3}>
            <div className="d-flex justify-content-center">
              <small>Advertisement</small>
            </div>

            <Link to="https://forms.gle/YZ8rr4Dzpwi4R3An7">
              <Image
                className="mx-auto d-block pt-2 border"
                src="https://ayg.s3.us-east-2.amazonaws.com/bharat/Beige+and+Maroon+traditional+Minimal+Guru+Purnima+Greeting+Instagram+Post.gif"
                fluid
              />
            </Link>
            <Link to="https://forms.gle/YZ8rr4Dzpwi4R3An7">
              <Image
                className="mx-auto d-block pt-2"
                src="https://ayg.s3.us-east-2.amazonaws.com/bharat/Beige+and+Brown+Illustrative+Krishna+Janmashtami+Greeting+Instagram+Post+(1).gif"
                fluid
              />
            </Link>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default ThailandVisaGuide;
